import React from 'react';
import { ArrowRightIcon, XIcon, CheckIcon, AlertCircleIcon, HeartPulseIcon } from 'lucide-react';
export function TwoChoicesSection() {
  return <section className="py-12 border-b border-gray-200" data-id="element-569">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-570">
        You Have Two Clear Choices
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-571">
        <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-572">
          <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center" data-id="element-573">
            <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center mr-3" data-id="element-574">
              <XIcon className="w-4 h-4 text-red-500" data-id="element-575" />
            </div>
            Keep Using Eye Drops
          </h3>
          {/* Path 1 header (red) */}
          <div className="flex items-center gap-2 text-red-600 font-semibold mb-3" data-id="element-576">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-577">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01M10.29 3.86l-7 12.12A2 2 0 005 19h14a2 2 0 001.71-3.02l-7-12.12a2 2 0 00-3.42 0z" data-id="element-578" />
            </svg>
            <h4 data-id="element-579">Path 1: Stay Trapped in the Drop Cycle</h4>
          </div>
          <ul className="space-y-3 mb-6" data-id="element-580">
            <li className="flex" data-id="element-581">
              <div className="text-red-500 mr-2" data-id="element-582">•</div>
              <p className="text-gray-700" data-id="element-583">
                Continue buying drops ($400-800 annually)
              </p>
            </li>
            <li className="flex" data-id="element-584">
              <div className="text-red-500 mr-2" data-id="element-585">•</div>
              <p className="text-gray-700" data-id="element-586">
                Blurred vision
              </p>
            </li>
            <li className="flex" data-id="element-587">
              <div className="text-red-500 mr-2" data-id="element-588">•</div>
              <p className="text-gray-700" data-id="element-589">
                Risk permanent loss of your oil-producing capacity
              </p>
            </li>
            <li className="flex" data-id="element-590">
              <div className="text-red-500 mr-2" data-id="element-591">•</div>
              <p className="text-gray-700" data-id="element-592">
                Kiss your mascara goodbye forever
              </p>
            </li>
            <li className="flex" data-id="element-593">
              <div className="text-red-500 mr-2" data-id="element-594">•</div>
              <p className="text-gray-700" data-id="element-595">
                Live with eyes that make you look and feel older
              </p>
            </li>
          </ul>
          <div className="border-t border-gray-200 pt-4 mt-4" data-id="element-596">
            <p className="text-gray-700 flex items-center" data-id="element-597">
              <AlertCircleIcon className="w-5 h-5 text-red-500 mr-2 flex-shrink-0" data-id="element-598" />
              <span data-id="element-599">
                Keep buying drops. Keep waking up with irritation and discomfort. But without addressing the root cause, symptoms often return again and again.
              </span>
            </p>
          </div>
        </div>
        <div className="bg-teal-50 p-6 rounded-lg border border-teal-200" data-id="element-600">
          <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center" data-id="element-601">
            <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-602">
              <CheckIcon className="w-4 h-4 text-green-500" data-id="element-603" />
            </div>
            Treat the Root Cause
          </h3>
          {/* Path 2 header (green) */}
          <div className="flex items-center gap-2 text-emerald-600 font-semibold mb-3" data-id="element-604">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-605">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-7.364 7.364a1 1 0 01-1.414 0L3.293 9.536a1 1 0 111.414-1.414l3.222 3.222 6.657-6.657a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-606" />
            </svg>
            <h4 data-id="element-607">Path 2: Support Your Natural Comfort System</h4>
          </div>
          <ul className="space-y-3 mb-6" data-id="element-608">
            <li className="flex" data-id="element-609">
              <div className="text-green-500 mr-2" data-id="element-610">•</div>
              <p className="text-gray-700" data-id="element-611">
                Break free with proven technology
              </p>
            </li>
            <li className="flex" data-id="element-612">
              <div className="text-green-500 mr-2" data-id="element-613">•</div>
              <p className="text-gray-700" data-id="element-614">
                Restore your eyes' natural oil flow in just 15 minutes dailys
              </p>
            </li>
            <li className="flex" data-id="element-615">
              <div className="text-green-500 mr-2" data-id="element-616">•</div>
              <p className="text-gray-700" data-id="element-617">
                Reduce or eliminate your dependency on drops
              </p>
            </li>
            <li className="flex" data-id="element-618">
              <div className="text-green-500 mr-2" data-id="element-619">•</div>
              <p className="text-gray-700" data-id="element-620">
                Protect and preserve your oil glands for life
              </p>
            </li>
            <li className="flex" data-id="element-621">
              <div className="text-green-500 mr-2" data-id="element-622">•</div>
              <p className="text-gray-700" data-id="element-623">
                Wake up with eyes that feel refreshed and look healthy
              </p>
               </li>
              <li className="flex" data-id="element-624">
              <div className="text-green-500 mr-2" data-id="element-625">•</div>
              <p className="text-gray-700" data-id="element-626">
                And yes, wear mascara again
              </p>
            </li>
          </ul>
          <div className="border-t border-teal-200 pt-4 mt-4" data-id="element-627">
            <p className="text-gray-700 flex items-center" data-id="element-628">
              <HeartPulseIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-629" />
              <span data-id="element-630">
                Treat the actual cause. Help your eyes’ natural system work the way it was designed. Feel more like yourself again.
              </span>
            </p>
          </div>
        </div>
      </div>
      <div className="mt-8 flex justify-center" data-id="element-631">
        <a href="https://irelief.us/products/vibration-bluetooth-eye-massager-visual-eye-massage-intelligent-eye-mask-massage-masajeador-heating-eyemask-face-facial-massager" className="w-full max-w-2xl" data-id="element-632">
          <div className="flex items-center bg-blue-50 p-4 rounded-lg border border-blue-100 cursor-pointer" data-id="element-633">
            <ArrowRightIcon className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0" data-id="element-634" />
            <p className="text-gray-700" data-id="element-635">
              <span className="font-semibold" data-id="element-636">The choice is clear:</span>{' '}
              Addressing the root cause with therapeutic heat not only provides
              relief but helps preserve your oil glands for long-term eye
              health.
            </p>
          </div>
          <div className="mt-6" data-id="element-637">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vGhF6X5ZCzNmfeLx3aqMmt/imgi_175_7cc21bd70030c675d629ad8551895491.webp" alt="Eye condition improvement over three weeks: Week 1 shows red, irritated eye; Week 2 shows reduced redness; Week 3 shows clear, healthy eye" className="w-full h-auto rounded-lg shadow-sm" width="800" height="400" loading="lazy" data-id="element-638" />
            <p className="text-sm text-gray-600 mt-2 text-center italic" data-id="element-639">
              Consistent daily heat therapy can make a visible difference.  
            Here’s an example of what some people have reported noticing within a few weeks of regular Oculis-3 use.
            </p>
          </div>
        </a>
      </div>
    </section>;
}